import { types as actions } from '../actions';

const defaultState = {
  showRp: false,
  showAp: false,
  showGateway: false,
  statusSummary: {},
  gatewayData: [],
  accessPointData: [],
  referencePointData: [],
  loading: true,
  loadingSummary: false,
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.GET_RP_DETAIL:
      return {
        ...state,
        showRp: true,
        showAp: false,
        showGateway: false,
        loading: true && !state.showRp,
      };
    case actions.SET_RP_DETAIL:
      return {
        ...state,
        referencePointData: [...action.referencePointData],
        loading: false || state.loadingSummary,
      };
    case actions.GET_AP_DETAIL:
      return {
        ...state,
        showAp: true,
        showRp: false,
        showGateway: false,
        loading: true && !state.showAp,
      };
    case actions.SET_AP_DETAIL:
      return {
        ...state,
        accessPointData: [...action.accessPointData],
        loading: false || state.loadingSummary,
      };
    case actions.GET_GATEWAY_DETAIL:
      return {
        ...state,
        showAp: false,
        showRp: false,
        showGateway: true,
        loading: true && !state.showGateway,
      };
    case actions.SET_GATEWAY_DETAIL:
      return {
        ...state,
        gatewayData: [...action.gatewayData],
        loading: false || state.loadingSummary,
      };
    case actions.RESET_STATUS_DETAIL:
      return {
        showAp: false,
        showRp: false,
        showGateway: false,
        loading: false,
      };
    case actions.DELETE_SITE_AP:
      state.accessPointData.filter(accessPoint => {
        return accessPoint.nodeAddress !== action.nodeAddress;
      });
      return {
        ...state
      };
    case actions.DELETE_SITE_AP_SUCCESS:
      const accessPointDataDeleteSuccess = state.accessPointData.filter(
        accessPoint => {
          return accessPoint.nodeAddress !== action.nodeAddress;
        }
      );
      return {
        ...state,
        accessPointData: accessPointDataDeleteSuccess
      };
    case actions.DELETE_SITE_GATEWAY:
      state.gatewayData.filter(gateway => {
        return gateway.nodeAddress !== action.nodeAddress;
      });
      return {
        ...state
      };
    case actions.DELETE_SITE_GATEWAY_SUCCESS:
      const gatewayDataDeleteSuccess = state.gatewayData.filter(gateway => {
        return gateway.nodeAddress !== action.nodeAddress;
      });
      return {
        ...state,
        gatewayData: gatewayDataDeleteSuccess
      };
    case actions.GET_STATUS_SUMMARY:
      let s = state.statusSummary || {}
      return {
        ...state,
        loading: true && Object.keys(s).length === 0,
        loadingSummary: true && Object.keys(s).length === 0,
      };
    case actions.SET_STATUS_SUMMARY:
      let ss = action.statusSummary || []
      let status = ss.reduce((h,s)=>{
        h[s.assetType]=s
        return h
      },{})
      return {
        ...state,
        statusSummary: status,
        loading: false,
        loadingSummary: false,
      };
    case actions.LOGGED_OUT:
        return defaultState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/status/index.js